import React from "react";

export const TapHandIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
    viewBox="-0.4 -0.4 164.4 243.1"
    zoomAndPan="magnify"
    style={{ fill: "#878B6A" }}
    width={props.width || "31.48552912900054px"}
    height={props.height || "46.55118554018897px"}
    {...props}
  >
    <g id="__id13_sm8oug2xy3">
      <path
        d="M163.75,186.28c0-13.82,0-27.63,0-41.45c0-3.41,0-6.83,0-10.24c-0.11-7.36-5.03-14.02-12.23-15.93 c-5.68-1.5-11.71,0.2-15.82,4.23c-0.1-1.43-0.33-2.86-0.82-4.24c-1.83-5.1-6.05-9.15-11.32-10.55c-4.61-1.22-9.78-0.38-13.67,2.41 c-0.77,0.55-1.48,1.16-2.14,1.82c-0.1-1.47-0.33-2.93-0.83-4.35c-1.81-5.05-5.93-9.04-11.13-10.5c-4.66-1.3-9.92-0.46-13.86,2.36 c-0.74,0.53-1.43,1.12-2.07,1.75c0-0.6,0-1.19,0-1.79c0-8.21,0-16.42,0-24.62c0-3.04,0-6.07,0-9.11c0-1.99,0.05-3.94-0.27-5.91 c-1.16-7.24-7.42-12.7-14.58-13.49c-6.22-0.69-12.43,2.49-15.7,7.79c-2.54,4.12-2.42,8.53-2.42,13.11c0,5.57,0,11.15,0,16.72 c0,7.97,0,15.94,0,23.9c0,8.43,0,16.86,0,25.3c0,6.96,0,13.91,0,20.87c0,2.35-0.04,4.72-0.04,7.07c-3.18-1.84-6.37-3.68-9.55-5.51 c-1.72-0.99-3.44-1.99-5.17-2.98c-2.82-1.63-5.6-3.49-8.85-4.09c-6.36-1.17-12.59,1.3-16.27,6.63c-2.91,4.2-3.63,9.94-1.86,14.74 c1.37,3.71,3.98,6.24,6.7,8.96c4.7,4.7,9.41,9.41,14.11,14.11c9.84,9.84,19.67,19.67,29.51,29.51c2.45,2.45,4.89,4.89,7.34,7.34 c2.04,2.04,3.98,4.25,6.19,6.11c2.29,1.92,4.84,3.13,7.79,3.62c3.26,0.54,6.58,0.53,9.87,0.76c6.92,0.48,13.85,0.87,20.78,1.25 c6.67,0.37,13.35,0.83,20.01,0.07c6.4-0.73,12.53-2.45,17.98-5.95c4.9-3.15,9.06-7.36,12.2-12.26c3.44-5.37,5.17-11.33,5.79-17.64 C164.03,199.51,163.75,192.85,163.75,186.28z M157.41,211.77c-2.61,10.45-10.97,19.53-21.11,23.15c-5.83,2.08-12.14,2.49-18.28,2.4 c-6.51-0.09-13.03-0.61-19.53-0.99c-3.3-0.19-6.6-0.39-9.89-0.61c-3.11-0.21-6.25-0.27-9.35-0.57c-2.47-0.24-4.8-0.88-6.75-2.48 c-2.1-1.72-3.92-3.84-5.84-5.76c-9.34-9.34-18.68-18.68-28.02-28.02c-8.31-8.31-16.62-16.62-24.93-24.93 c-1.1-1.1-2.18-2.15-2.98-3.51c-1.06-1.81-1.59-3.87-1.57-5.97c0.05-4.48,2.9-8.97,7.25-10.39c2.61-0.86,5.44-0.79,7.99,0.24 c1.32,0.53,2.56,1.37,3.79,2.08c1.25,0.72,2.5,1.44,3.75,2.17c4.99,2.88,9.97,5.76,14.96,8.64c0.4,0.23,0.8,0.46,1.2,0.69 c1.64,0.95,3.76-0.26,3.76-2.16c0-2.43,0-4.86,0-7.29c0-6.1,0-12.21,0-18.31c0-8,0-16.01,0-24.01c0-8.13,0-16.26,0-24.38 c0-6.45,0-12.9,0-19.35c0-3.07-0.01-6.14,0-9.21c0.02-3.67,1.63-7.15,4.59-9.37c4.65-3.47,11.3-2.85,15.28,1.35 c2.36,2.49,3.1,5.62,3.1,8.94c0,2.32,0,4.64,0,6.96c0,7.85,0,15.7,0,23.54c0,5.93,0,11.86,0,17.79c0,0.31,0,0.63,0,0.94 c0,3.22,4.96,3.22,5,0c0.09-7.39,7.16-13.05,14.41-11.12c3.98,1.06,7.13,4.21,8.18,8.18c0.58,2.18,0.38,4.57,0.38,6.8 c0,2.27,0,4.53,0,6.8c0,3.22,4.96,3.22,5,0c0.09-7.4,7.16-13.02,14.42-11.11c3.97,1.05,7.13,4.22,8.18,8.18 c0.57,2.13,0.37,4.44,0.37,6.62c0,2.29,0,4.58,0,6.87c0,3.22,4.96,3.22,5,0c0.07-5.69,4.34-10.76,10.09-11.42 c6.83-0.78,12.78,4.6,12.88,11.42c0,13.1,0,26.19,0,39.29c0,6.71,0,13.43,0,20.14C158.75,199.95,158.86,205.98,157.41,211.77z M55.09,29.08L55.09,29.08c-2.35,0.51-4.67-0.98-5.18-3.33L45.46,5.28c-0.51-2.35,0.98-4.67,3.33-5.18l0,0 c2.35-0.51,4.67,0.98,5.18,3.33l4.46,20.47C58.93,26.25,57.44,28.57,55.09,29.08z M33.19,43.95L33.19,43.95 c-1.28,2.04-3.96,2.66-6,1.38L9.43,34.2c-2.04-1.28-2.66-3.96-1.38-6l0,0c1.28-2.04,3.96-2.66,6-1.38l17.75,11.12 C33.85,39.22,34.46,41.91,33.19,43.95z M29.08,70.42L29.08,70.42c0.51,2.35-0.98,4.67-3.33,5.18L5.28,80.06 c-2.35,0.51-4.67-0.98-5.18-3.33l0,0c-0.51-2.35,0.98-4.67,3.33-5.18l20.47-4.46C26.25,66.58,28.57,68.07,29.08,70.42z M81.19,33.63 L81.19,33.63c-2.04-1.28-2.66-3.96-1.38-6L90.94,9.88c1.28-2.04,3.96-2.66,6-1.38l0,0c2.04,1.28,2.66,3.96,1.38,6L87.2,32.25 C85.92,34.29,83.23,34.91,81.19,33.63z M95.88,54.6L95.88,54.6c-0.51-2.35,0.98-4.67,3.33-5.18l20.47-4.46 c2.35-0.51,4.67,0.98,5.18,3.33v0c0.51,2.35-0.98,4.67-3.33,5.18l-20.47,4.46C98.71,58.45,96.39,56.95,95.88,54.6z"
        fill={props.fill ?? "inherit"}
      />
    </g>
  </svg>
);

export const CreditCard = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
    viewBox="6.3 26.6 115.4 74.8"
    zoomAndPan="magnify"
    style={{ fill: "#878b6a" }}
    width={props.width || "77.71284958171394px"}
    height={props.height || "50.44270418303978px"}
    {...props}
  >
    <g id="__id14_sm8oug2xy3">
      <path
        d="M115.7,26.6H12.3a6,6,0,0,0-6,6V95.4a6,6,0,0,0,6,6H115.7a6,6,0,0,0,6-6V32.6A6,6,0,0,0,115.7,26.6Zm4,68.8a4,4,0,0,1-4,4H12.3a4,4,0,0,1-4-4V32.6a4,4,0,0,1,4-4H115.7a4,4,0,0,1,4,4Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M19,54.89H30.55a4,4,0,0,0,4-4V39.31a4,4,0,0,0-4-4H19a4,4,0,0,0-4,4V50.89A4,4,0,0,0,19,54.89Zm11.57-2H25.77V46.1h6.78v4.79A2,2,0,0,1,30.55,52.89Zm2-13.58V44.1H25.77V37.31h4.78A2,2,0,0,1,32.55,39.31ZM17,39.31a2,2,0,0,1,2-2h4.79V52.89H19a2,2,0,0,1-2-2Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M17.32,64.93v5.63a1,1,0,0,0,2,0V64.93a1,1,0,0,0-2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M25.41,64.93v5.63a1,1,0,0,0,2,0V64.93a1,1,0,0,0-2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M33.5,64.93v5.63a1,1,0,0,0,2,0V64.93a1,1,0,1,0-2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M94.5,70.56V64.93a1,1,0,1,0-2,0v5.63a1,1,0,0,0,2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M102.59,70.56V64.93a1,1,0,1,0-2,0v5.63a1,1,0,0,0,2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M110.68,70.56V64.93a1,1,0,1,0-2,0v5.63a1,1,0,0,0,2,0Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M51.86,71.56a1,1,0,0,0,1-1V64.93a1,1,0,0,0-2,0v5.63A1,1,0,0,0,51.86,71.56Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M60,71.56a1,1,0,0,0,1-1V64.93a1,1,0,0,0-2,0v5.63A1,1,0,0,0,60,71.56Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M68.05,71.56a1,1,0,0,0,1-1V64.93a1,1,0,1,0-2,0v5.63A1,1,0,0,0,68.05,71.56Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M76.14,71.56a1,1,0,0,0,1-1V64.93a1,1,0,1,0-2,0v5.63A1,1,0,0,0,76.14,71.56Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M76.76,83H16a1,1,0,0,0,0,2H76.76a1,1,0,0,0,0-2Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M59.75,90.69H16a1,1,0,0,0,0,2H59.75a1,1,0,0,0,0-2Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M112,83H90.28a1,1,0,0,0-1,1v7.67a1,1,0,0,0,1,1H112a1,1,0,0,0,1-1V84A1,1,0,0,0,112,83Zm-1,7.67H91.28V85H111Z"
        style={{ fill: "inherit" }}
      />
      <path
        d="M112,35.31H90.28a1,1,0,0,0,0,2H112a1,1,0,0,0,0-2Z"
        style={{ fill: "inherit" }}
      />
    </g>
  </svg>
);

export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    // fill="#000000"
    // width="24px"
    // height="24px"
    width={props.width || "24px"}
    height={props.height || "24px"}
    viewBox="-3.5 0 19 19"
    // className="cf-icon-svg"
    {...props}
  >
    <path
      d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"
      fill={props.fill || "#8c906c"}
    />
  </svg>
);

export const UndoStrokeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="#8c906c"
    // width="800px"
    // height="800px"
    width={props.width || "31.48552912900054px"}
    height={props.height || "46.55118554018897px"}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.70710678,16 L7.85355339,19.1464466 C8.04881554,19.3417088 8.04881554,19.6582912 7.85355339,19.8535534 C7.65829124,20.0488155 7.34170876,20.0488155 7.14644661,19.8535534 L3.14644661,15.8535534 C2.95118446,15.6582912 2.95118446,15.3417088 3.14644661,15.1464466 L7.14644661,11.1464466 C7.34170876,10.9511845 7.65829124,10.9511845 7.85355339,11.1464466 C8.04881554,11.3417088 8.04881554,11.6582912 7.85355339,11.8535534 L4.70710678,15 L18.5,15 C19.3284271,15 20,14.3284271 20,13.5 L20,7.5 C20,6.67157288 19.3284271,6 18.5,6 L3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 L18.5,5 C19.8807119,5 21,6.11928813 21,7.5 L21,13.5 C21,14.8807119 19.8807119,16 18.5,16 L4.70710678,16 Z"
      fill="none"
      stroke="#8c906c"
      strokeWidth="2"
    />
    {/* Capa de relleno principal */}
    <path
      d="M4.70710678,16 L7.85355339,19.1464466 C8.04881554,19.3417088 8.04881554,19.6582912 7.85355339,19.8535534 C7.65829124,20.0488155 7.34170876,20.0488155 7.14644661,19.8535534 L3.14644661,15.8535534 C2.95118446,15.6582912 2.95118446,15.3417088 3.14644661,15.1464466 L7.14644661,11.1464466 C7.34170876,10.9511845 7.65829124,10.9511845 7.85355339,11.1464466 C8.04881554,11.3417088 8.04881554,11.6582912 7.85355339,11.8535534 L4.70710678,15 L18.5,15 C19.3284271,15 20,14.3284271 20,13.5 L20,7.5 C20,6.67157288 19.3284271,6 18.5,6 L3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 L18.5,5 C19.8807119,5 21,6.11928813 21,7.5 L21,13.5 C21,14.8807119 19.8807119,16 18.5,16 L4.70710678,16 Z"
      fill="#8c906c"
    />
  </svg>
);

export const ReloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 446.895 446.895"
    // style={{
    //   enableBackground: "new 0 0 446.895 446.895",
    // }}
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <g>
        <path
          style={{
            fill: "white",
          }}
          d="M223.447,446.895c-101.311,0-183.738-82.42-183.738-183.738 c0-93.853,71.811-173.051,164.495-182.712V0l30.95,21.176l132.381,76.066l-132.703,79.055l-30.634,20.275v-77.193 c-72.283,9.452-126.002,70.158-126.002,143.784c0,80.093,65.158,145.252,145.252,145.252c79.723,0,144.876-64.86,145.234-144.589 v-30.986h38.504l-0.197,38.033C402.913,368.46,321.787,446.895,223.447,446.895z M216.132,22.614v68.834l-5.531,0.406 c-89.139,6.57-158.963,81.812-158.963,171.303c0.006,94.736,77.074,171.804,171.81,171.804 c93.805,0,170.855-76.31,171.756-170.115l0.048-20.079h-14.637v19.082c-0.388,86.305-70.892,156.499-157.167,156.499 c-86.669,0-157.185-70.51-157.185-157.185c0-82.044,61.644-149.273,143.39-156.38l6.48-0.567v68.148l12.351-8.175l115.417-68.768 L228.806,31.272L216.132,22.614z"
        />
      </g>
    </g>
  </svg>
);
